import { LogsRoutingModule } from './logs.routing.module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedAppModule } from '../app.module.shared';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


import { AdminLogsComponent } from './admin.logs/admin.logs.component';
import { GlobalActivityStreamComponent } from './global.activity.stream/global.activity.stream.component';



@NgModule({
    declarations: [
        AdminLogsComponent,
        GlobalActivityStreamComponent,
    ],
    imports: [
        CommonModule,
        SharedAppModule,
        ReactiveFormsModule,
        FormsModule,

        LogsRoutingModule
    ],
    entryComponents: [

    ]
})

export class LogsModule { }
